import type { ActionButtonType, PrimaryPageAction } from "@octopusdeploy/design-system-components";
import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import type { TemplateParameterResource, ActionTemplateParameterResource } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import TemplateParameterEditorDialog from "~/areas/platformHub/processTemplates/TemplateParameterEditorDialog";
import { SortActionTemplateParametersButton } from "~/components/ActionTemplateParametersList/index";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import PermissionCheck, { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
interface AddTemplateParameterButtonProps {
    parameters: TemplateParameterResource[];
    onAdd: (parameter: TemplateParameterResource) => void;
    type: ActionButtonType;
}
export function AddTemplateParameterButton({ parameters, onAdd, type }: AddTemplateParameterButtonProps) {
    return (<PermissionCheck key="AddParameterPermission" {...parameterEditPermission}>
            <OpenDialogButton key="AddParameter" label={`Add parameter`} type={type} renderDialog={({ open, closeDialog }) => (open ? <TemplateParameterEditorDialog allParameters={parameters} onOk={onAdd} open={open} close={closeDialog}/> : null)}/>
        </PermissionCheck>);
}
interface OpenReorderParametersButtonProps {
    parameters: TemplateParameterResource[];
    onChange: (parameters: ActionTemplateParameterResource[]) => void;
}
export function OpenReorderParametersButton({ parameters, onChange }: OpenReorderParametersButtonProps) {
    return <SortActionTemplateParametersButton parameters={parameters} onChange={onChange} permission={parameterEditPermission} name={"parameter"}/>;
}
interface ParametersOnboardingProps {
    parameters: TemplateParameterResource[];
    onAdd: (parameter: TemplateParameterResource) => void;
}
export function TemplateParametersOnboarding({ onAdd, parameters }: ParametersOnboardingProps) {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const addParameterAction: PrimaryPageAction = {
        type: "button",
        label: "Add Parameter",
        onClick: () => setIsDialogOpen(true),
        hasPermissions: isAllowed(parameterEditPermission),
    };
    return (<>
            <TemplateParameterEditorDialog allParameters={parameters} onOk={onAdd} open={isDialogOpen} close={() => setIsDialogOpen(false)}/>
            <InlineEmptyStateOnboarding title="This template doesn’t have any parameters yet." description="Start creating by clicking on Add Parameter" illustration="NoEntities" actions={{ primary: addParameterAction }}/>
        </>);
}
const parameterEditPermission = {
    permission: Permission.PlatformHubEdit,
};
